var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibleOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.563 7.118a2.657 2.657 0 013.104-3.201M12.01 4.622c.56.457.793 1.119.793 1.897a2.657 2.657 0 01-4.554 1.859",
    stroke: "#E0E2E4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.404 2.545c2.768 1.493 4.636 3.828 4.636 3.828-.005.166-4.038 5.046-9.02 5.046-1.343 0-2.617-.365-3.766-.905M4.644 9.614C2.43 8.164 1 6.378 1 6.378s4.038-5.045 9.02-5.045c1.017 0 2 .21 2.91.545",
    stroke: "#E0E2E4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgVisibleOn;